import loadAuthenticationModule from './modules/Authentication.module';
import loadAuthenticationFormModule from './modules/AuthenticationForm.module';
const loadDpeActivatorModule = () => ({
    hasRouter: false,
    modules: [loadAuthenticationModule(), loadAuthenticationFormModule()],
});
export default loadDpeActivatorModule;
